var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.37996 12.5467C6.25329 12.5467 6.12663 12.5001 6.02663 12.4001L1.97996 8.35341C1.78663 8.16008 1.78663 7.84008 1.97996 7.64674L6.02663 3.60008C6.21996 3.40674 6.53996 3.40674 6.73329 3.60008C6.92663 3.79341 6.92663 4.11341 6.73329 4.30674L3.03996 8.00008L6.73329 11.6934C6.92663 11.8867 6.92663 12.2067 6.73329 12.4001C6.63996 12.5001 6.50663 12.5467 6.37996 12.5467Z","fill":"#1C1C28","key":0}),React.createElement("path",{"d":"M13.6663 8.5H2.44629C2.17296 8.5 1.94629 8.27333 1.94629 8C1.94629 7.72667 2.17296 7.5 2.44629 7.5H13.6663C13.9396 7.5 14.1663 7.72667 14.1663 8C14.1663 8.27333 13.9396 8.5 13.6663 8.5Z","fill":"#1C1C28","key":1})]);
}

ArrowBack.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
